import { render } from "./payment.vue?vue&type=template&id=090f490a"
import script from "./payment.vue?vue&type=script&lang=js"
export * from "./payment.vue?vue&type=script&lang=js"

import "./payment.vue?vue&type=style&index=0&id=090f490a&lang=css"

import exportComponent from "C:\\Users\\home\\Documents\\GitHub\\childu_usersite\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__